<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="onlinetest !== null">

    <div class="p-grid">
        <div class="p-col-6">
            <h2>{{ t('common.labels.competences') }}</h2>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit !== true && all.length > onlinetest.competences.length">
          <button withRight="admin.onlinetest.edit" pButton (click)="onNew()" type="button" label="{{ t('common.labels.new') }}" icon="pi pi-plus" class="p-button-sm p-button-success p-mb-2 autofocus"></button>
        </div>
    </div>

    <p-table *ngIf="inEdit === true || onlinetest.competences?.length > 0" [value]="onlinetest.competences">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 25%;">{{ t('common.labels.competence') }}</th>
                <th *ngIf="onlinetest.with_behavioranchors === true">{{ t('common.labels.behavioranchors') }}</th>
                <th style="width: 10rem;"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-competence>
          <tr *ngIf="inEdit !== true || editEntry !== competence ">
            <td><p>{{ competence.getLang('name', transloco.getActiveLang()) }}</p></td>
            <td *ngIf="onlinetest.with_behavioranchors === true">
              <p *ngFor="let behavioranchor of competence.pivot.behavioranchors">{{ behavioranchor.content }}</p>
            </td>
            <td style="vertical-align: top; text-align: right">
              <span *ngIf="inEdit !== true">
                <button *ngIf="onlinetest.with_behavioranchors === true" withRight="admin.onlinetest.edit" pButton (click)="onEdit(competence)" type="button" icon="pi pi-pencil" aria-label="{{ t('common.labels.edit') }}"></button>
                <button withRight="admin.onlinetest.edit" pButton (click)="onDelete(competence)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button p-ml-2" aria-label="{{ t('common.labels.delete') }}"></button>
              </span>
            </td>
          </tr>
          <tr *ngIf="inEdit === true && editEntry === competence">
            <ng-template [ngTemplateOutlet]="tForm"></ng-template>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr *ngIf="inEdit === true && editEntry === null">
            <ng-template [ngTemplateOutlet]="tForm"></ng-template>
          </tr>
        </ng-template>
    </p-table>

    <ng-template #tForm>
      <td style="vertical-align: top;">
        <app-form-control [cid]="'competence'" [control]="form.get('competence')" [type]="'select'" [options]="optionsCompetences" [optionLabel]="'name.' + transloco.getActiveLang().toUpperCase()"  [showLabel]="false" [noMargin]="true"></app-form-control>
      </td>
      <td *ngIf="onlinetest.with_behavioranchors === true">
        <div *ngFor="let control of form.get('behavioranchors')['controls']; let i = index" class="p-grid">
            <div class="p-col">
              <app-form-control [cid]="'behavioranchor' + i" [control]="control.get('content')" [type]="'input'" [showLabel]="false" [noMargin]="true"></app-form-control>
            </div>
            <div class="p-col-fixed" style="width: 30px;">
              <button *ngIf="form.get('behavioranchors')['controls'].length > 1" pButton (click)="deleteBehavioranchorEntry(i)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button"></button>
            </div>
        </div>
        <a (click)="addBehavioranchorEntry()" class="pointer"><fa-icon [icon]="faPlus"></fa-icon> {{ t('common.labels.add_behavioranchors') }}</a>
      </td>
      <td style="vertical-align: top; text-align: right">
        <app-form-buttons [submitting]="submitting" [icons]="false" (cancelled)="onCancel()"></app-form-buttons>
      </td>
    </ng-template>

    <p *ngIf="inEdit !== true && onlinetest.competences?.length === 0">{{ t('common.texts.no_competences') }}</p>

  </form>
</ng-container>
